import React from "react";
import "./style.css";
import { useSelector } from "react-redux";
import { Divider, View, Heading, Text } from "@adobe/react-spectrum";
import { RootState } from "../../../store/storeConfig";
import { IndividualTask } from "../../../amazon-connect/models/task";
import CaseInformationHeader from "../CaseInformationContainer/CaseInformationHeader";
import CaseDetails from "../CaseInformationContainer/CaseDetails";
import CaseInfoDetail from "../CaseInformationContainer/CaseInfoDetail";

interface CaseHistoryWebProps {
  caseID: string;
}

const CaseHistoryWeb: React.FC<CaseHistoryWebProps> = ({ caseID }) => {
  let history = useSelector((state: RootState) => state.history);
  let combinedHistoryItems = [...history.cases];
  const activeCase = combinedHistoryItems.find(
    (indCase: IndividualTask) => indCase.id === caseID
  );

  return (
    <View UNSAFE_className="caseinformationcontainer-wrapper">
      {combinedHistoryItems.length > 0 ? (
        <>
          <View UNSAFE_className="container-header">
            <CaseInformationHeader activeCase={activeCase} tabName="history" />
          </View>
          <Divider size="M" />
          <View UNSAFE_className="case-details-scroll-container">
            <CaseDetails activeCase={activeCase} />
          </View>
          <View UNSAFE_className="container-information" marginTop={"5px"} marginBottom={"16px"}>
              <CaseInfoDetail activeCase={activeCase} />
          </View>
        </>
      ) : (
        <View UNSAFE_className="noActiveCases">
          <div className="noActiveCases-description">
            <Text>No cases available.</Text>
          </div>
        </View>
      )}
    </View>
  );
};

export default CaseHistoryWeb;